// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 984 ? "reactPlayerPreview" : chunkId) + "." + {"592":"543c446b","984":"f8c0806a"}[chunkId] + ".chunk.js";
};